import React from 'react';
import { useSpring, animated } from 'react-spring';

const Contact = () => {
  const slideIn = useSpring({
    opacity: 1,
    from: { opacity: 0, x: -100 },
    config: { duration: 800 },
  });

  return (
    <animated.div style={slideIn} className="container mx-auto py-16">
      <h2 className="text-4xl font-bold text-center mb-8">Contact</h2>
      <form className="max-w-2xl mx-auto">
        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Name</label>
          <input type="text" className="w-full p-3 border border-gray-300 rounded-lg" placeholder="Your Name" />
        </div>
        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Email</label>
          <input type="email" className="w-full p-3 border border-gray-300 rounded-lg" placeholder="Your Email" />
        </div>
        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Message</label>
          <textarea className="w-full p-3 border border-gray-300 rounded-lg" rows="5" placeholder="Your Message"></textarea>
        </div>
        <button type="submit" className="bg-gray-800 text-white px-6 py-3 rounded-lg hover:bg-gray-700 transition duration-300">
          Send Message
        </button>
      </form>
    </animated.div>
  );
};

export default Contact;